export default __webpack_public_path__ + "static/media/icon-conference.e9bf6a3f.svg";